"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Show(_a) {
    var event = _a.event, onEdit = _a.onEdit;
    return (react_1.default.createElement("div", { className: 'storybook-events-create-form' },
        react_1.default.createElement("div", null,
            react_1.default.createElement(storybook_1.Forms.Thumbnail, { disabled: true, image: event.thumbnail, icon: 'camera', label: 'Banner vervangen' })),
        react_1.default.createElement("div", { className: 'storybook-events-show' },
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement("div", { className: 'text-left' },
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, event.title),
                    react_1.default.createElement(storybook_1.Texts.Small, { className: 'text-gray-400' }, event.start_label))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onEdit, icon: 'pencil', type: 'default' }, "Bewerken")))));
}
exports.default = Show;
